"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDTH = exports.SURPRISE_LINK_SNIPPET = exports.SURPRISE_LINK = exports.SMALL_FONT_SIZE = exports.SMALL = exports.SIZE = exports.OPACITY = exports.MEDIUM_FONT_SIZE = exports.MEDIUM = exports.LOADING = exports.LARGE_FONT_SIZE = exports.LARGE = exports.HEIGHT = exports.COMPONENT = exports.BASKETITEM_FONT_SIZE = exports.BASKETITEM = exports.BACKGROUND = void 0;
// default values
const SIZE = exports.SIZE = 'medium';
const BACKGROUND = exports.BACKGROUND = undefined;
const OPACITY = exports.OPACITY = 1;
const LOADING = exports.LOADING = 'lazy';
const COMPONENT = exports.COMPONENT = 'span';
// sizes
const SMALL = exports.SMALL = {
  sm: 38,
  md: 38
};
const SMALL_FONT_SIZE = exports.SMALL_FONT_SIZE = {
  sm: '2.8',
  md: '2.8'
};
const MEDIUM = exports.MEDIUM = {
  sm: 90,
  md: 90
};
const MEDIUM_FONT_SIZE = exports.MEDIUM_FONT_SIZE = {
  sm: '5.5',
  md: '5.5'
};
const LARGE = exports.LARGE = {
  sm: 160,
  md: 160
};
const LARGE_FONT_SIZE = exports.LARGE_FONT_SIZE = {
  sm: '10.5',
  md: '10.5'
};
const BASKETITEM = exports.BASKETITEM = {
  sm: 120,
  md: 150
};
const BASKETITEM_FONT_SIZE = exports.BASKETITEM_FONT_SIZE = {
  sm: '7.5',
  md: '9.5'
};
const WIDTH = exports.WIDTH = '100%';
const HEIGHT = exports.HEIGHT = '100%';
// surprise stuff
const SURPRISE_LINK = exports.SURPRISE_LINK = 'https://media-we-cdn.oriflame.com/contentImage?externalMediaId=1ad93e51-63b6-47e0-a74a-4f0c222faf2a&name=surprise_gift&inputFormat=png';
const SURPRISE_LINK_SNIPPET = exports.SURPRISE_LINK_SNIPPET = '/images/surprise.jpg';
